<script lang="ts" setup>

</script>

<template>
    <slot/>
</template>
